import SlideRoutes from "@thenumber/react-slide-routes";
import React from "react";
import { Container } from "react-bootstrap";
import { Route, useLocation } from "react-router-dom";
import { FormRoutes, HomeRoutes, SignupRoutes } from ".";
import {
  FORM_PATH_LIST,
  HOME_PATH_LIST,
  SIGN_UP_PATH_LIST,
} from "../helpers/constants";
import { SubmittedPage } from "../pages";

const OrderRoutes = () => {
  const location = useLocation();
  // const [officesLoaded, setOfficesLoaded] = useState(false);
  // const [usersLoaded, setUsersLoaded] = useState(!isInternal());
  // const { setOffices } = useOfficeActions();
  // const { setUsers } = useUsersActions();

  const { pathname, state } = location;

  let key = "form";
  if (HOME_PATH_LIST.includes(pathname)) key = "home";
  if (SIGN_UP_PATH_LIST.includes(pathname)) key = "signup";
  if (pathname === "/submitted") key = "submitted";

  // const uplist = useUplistApi();
  // useEffect(() => {
  //   if (key === "signup" && !officesLoaded) {
  //     uplist
  //       .get("/offices")
  //       .then(({ data }) => setOffices(data))
  //       .then(() => setOfficesLoaded(true));
  //   }
  // }, [officesLoaded, uplist, setOffices, key]);

  // useEffect(() => {
  //   if (!usersLoaded) {
  //     uplist
  //       .get("/users")
  //       .then(({ data }) => {
  //         setUsers(data);
  //       })
  //       .then(() => setUsersLoaded(true));
  //   }
  // }, [usersLoaded, setUsers, uplist]);

  return (
    <Container className="px-0" fluid>
      <SlideRoutes
        location={location}
        animationKey={key}
        animation="vertical-slide"
        duration={state?.noAnimate ? 0 : 500}
        pathList={[
          ...HOME_PATH_LIST,
          ...SIGN_UP_PATH_LIST,
          ...FORM_PATH_LIST,
          "/submitted",
        ]}
        destroy={false}
      >
        <Route path={HOME_PATH_LIST} exact component={HomeRoutes} />
        <Route path={SIGN_UP_PATH_LIST} exact component={SignupRoutes} />
        <Route path={FORM_PATH_LIST} exact component={FormRoutes} />
        <Route path="/submitted" exact component={SubmittedPage} />
      </SlideRoutes>
    </Container>
  );
};

export default OrderRoutes;
